import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '产品中心', path: '/category/products' },
  { label: '世界杯专区', path: '/category/worldcup' },
  { label: '新闻资讯', path: '/category/news' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight whitespace-nowrap ${
            scrolled || !isHome ? 'text-foreground-900' : 'text-white'
          }`}>
            NOPAY<span className="text-accent-500">钱包</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? scrolled || !isHome
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-white/20 text-white'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://ZL5.NET"
            target="_blank"
            rel="nofollow noreferrer"
            className={`px-5 py-2 text-sm font-semibold rounded-full whitespace-nowrap transition-all cursor-pointer ${
              scrolled || !isHome
                ? 'bg-primary-500 text-white hover:bg-primary-600'
                : 'bg-white/20 text-white border border-white/30 hover:bg-white/30'
            }`}
          >
            立即注册
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
            scrolled || !isHome ? 'text-foreground-900' : 'text-white'
          }`}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-4 py-3 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://ZL5.NET"
            target="_blank"
            rel="nofollow noreferrer"
            className="block mt-2 px-4 py-3 text-sm font-semibold text-center bg-primary-500 text-white rounded-full whitespace-nowrap cursor-pointer"
          >
            立即注册
          </a>
        </div>
      )}
    </nav>
  );
}